import VideoModal from '../_modal/VideoModal'

let sharedVideoModal = null;

class ModalVideo {
  constructor(el) {
    this.el = el;
    // 共有モーダルを用意（重複生成防止）
    if (!sharedVideoModal) {
      sharedVideoModal = new VideoModal();
    }
    this.videoModal = sharedVideoModal;

    this.#bind();
  }

  #bind() {
    if (!this.el) return;
    this.el.addEventListener('click', (e) => {
      e.preventDefault();
      const videoId = this.el.dataset.id;
      const lat = this.el.dataset.lat;
      const lng = this.el.dataset.lng;
      const municipalities = this.el.dataset.municipalities;
      const copy = this.el.dataset.copy;
      const eyecatch = this.el.dataset.eyecatch;
      
      if (videoId) {
        this.videoModal.open(videoId, lat, lng, municipalities, copy, eyecatch);
      } else {
        console.warn('[ModalVideo] data-id が見つかりませんでした。');
      }
    });
  }
}

export default ModalVideo;
